<template>
  <div>
    <div class="noticia mt-4">
      <div
        class="contenedor-noticia text-left h-100"
        v-for="(item,index) in DetalleNoticia"
        :key="index"
      >
        <div class="contenedor-titulo font-weight-bold border-top py-3">
          <h1 class="m-0 pb-0">{{item.titulo}}</h1>
        </div>
        <div class="mb-3 py-2 border-top border-bottom d-flex">
          <div class="col-md-6 d-flex align-items-center p-0">
            <div class="contenedor-datos">
              <b>República Dominicana &nbsp;</b>
              <span>{{item.fecha}}</span>
            </div>
          </div>
          <social-sharing
         
            :title="item.titulo"
            :description="item.descripcion"
            :quote="item.titulo"
            hashtags="ADGSystems, Noticias, Software"
            inline-template
          >
            <div class="col-md-6 d-flex justify-content-end p-0 text-white">
              <network
                network="facebook"
                id="facebook"
                class="contenedor-icon d-flex justify-content-center align-items-center mr-1"
                style="background: #3b5999;   
                       width: 38px;
                       height: 38px;
                       padding: 7px;
                       border-radius: 200px;
                       font-size: 1.4em;"
              >
                <i class="fab fa-facebook-f text-icon"></i>
              </network>
              <network
                network="twitter"
                id="twitter"
                class="contenedor-icon d-flex justify-content-center align-items-center mr-1"
                style="background: #00acee;  width: 38px;
                       height: 38px;
                       padding: 7px;
                       border-radius: 200px;
                       font-size: 1.4em; "
              >
                <i class="fab fa-twitter"></i>
              </network>
              <network
                network="whatsapp"
                id="whatsapp"
                class="contenedor-icon d-flex justify-content-center align-items-center mr-1"
                style="background: #25D366;  width: 38px;
                       height: 38px;
                       padding: 7px;
                       border-radius: 200px;
                       font-size: 1.4em;"
              >
                <i class="fab fa-whatsapp"></i>
              </network>
              <network
                network="telegram"
                id="telegram"
                class="contenedor-icon d-flex justify-content-center align-items-center mr-1"
                style="background: #0088CC;  width: 38px;
                       height: 38px;
                       padding: 7px;
                       border-radius: 200px;
                       font-size: 1.4em; "
              >
                <i class="fab fa-telegram-plane"></i>
              </network>
            </div>
          </social-sharing>
        </div>
        <div class="contenedor-imagen">
          <div class>
            <img :src="item.imagen" class="d-block mx-auto mx-lg-0" />
          </div>
        </div>
        <div class="contenedor-autor py-3">{{item.autor}}</div>
        <hr class="m-0" />
        <div class="row w-100 py-3">
          <div class="contenedor-descripcion col-md-8">
            <h2>{{item.subtitulo}}</h2>
            <p class>{{item.descripcion}}</p>
          </div>
          <div class="col-md-4">
            <p>{{item.descripcionLateral}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
   
      DetalleNoticia: []
    };
  },
  components: {},
  computed: {
    ...mapState(["Noticias", "PublicidadNoticias"])
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    this.noticia(this.$route.params.id);
    this.$store.state.colorHeader = true;
  },
  destroyed() {
    this.$store.state.colorHeader = false;
  },
  methods: {
    noticia(value) {
      this.Noticias.forEach(item => {
        if (item.id == value) {
          this.DetalleNoticia.push(item);
        }
      });
    }
  }
};
</script>
<style scoped>
.portada-blog {
  height: 240px;
  width: 100%;
  color: white;
  background-image: linear-gradient(
    to top,
    rgba(0, 156, 255, 1),
    rgba(13, 66, 178, 1)
  );
}
.noticia {
  padding: 50px 6%; 
}
.contenedor-noticia {
  background: #fff;
}
h2 {
  font-size: 1.8em;
  color: #666666;
}
.contenedor-imagen img {
  max-width: 100%;
  max-height: 640px;
}
@media screen and (max-width: 1280px) {
  .text-icon {
    width: 30px;
    height: 30px;
    padding: 7px;
  }
  .contenedor-icon {
    display: block;
    width: 30px;
    height: 30px;
    margin-left: 6px;
  }
}
.contenedor-titulo {
  font-family: "Majerit", serif;
}
.contenedor-titulo h1 {
  margin: 0 !important;
}
.contenedor-titulo h2 {
  font-size: 1.8em;
}
@media screen and (max-width: 480px) {
  .contenedor-titulo h2 {
    font-size: 1.3em;
  }
  .contenedor-titulo h1 {
    font-size: 1.8em;
  }
}
.contenedor-imagen img {
  max-width: 100%;
}
.contenedor-autor {
  font-size: 0.85em;
}
.contenedor-datos {
  font-size: 1em;
}
.text-icon {
  color: #fff;
}
.contenedor-icon {
  display: block;
  width: 38px;
  height: 38px;
  margin: 5px 5px;
}

/* .ig-icon {
  background: #d6249f;
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  ) !important;
} */
</style>